import { useTranslation } from 'react-i18next';
import Tabs, { type TabItem } from '@/components/base/Tabs';
import type { FinancePeriod } from '@/services/financeService';

const PERIODS: FinancePeriod[] = ['today', 'week', 'month'];

interface PeriodSelectorProps {
  value: FinancePeriod;
  onChange: (period: FinancePeriod) => void;
}

export default function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
  const { t } = useTranslation();
  const items: TabItem[] = PERIODS.map((id) => ({ id, label: t(`finance.period.${id}`) }));
  return (
    <Tabs items={items} active={value} onChange={(id) => onChange(id as FinancePeriod)} />
  );
}